import React from 'react';
import Commons from 'oc-commons/Commons';

export default class SidebarFrame extends React.Component {

    getSidebarParent() {
        return null;
    }

    render() {
        return (
            <aside  id="scroll-sidebar" className="sidebar">
                <div className="inner-sidebar">
                    <div className="sidebar-header row">
                        <div className="left col-1">
                        </div>
                        <div className="middle col-9">
                            <div className="sidebar-title">
                                {this.renderTitle()}
                            </div>
                        </div>
                        <div className="right col-2">
                        </div>
                    </div>
                    <div className="sidebar-body">

                        {this.renderBody()}

                        <div className={"button-wrapper text-right " + (Commons.isEmpty(this.getSidebarParent()) ? "only-mobile " : "") }>
                            <button className="button primary big-button appear" onClick={() => APP.uiHandler.sidebar(this.getSidebarParent())} href="#">{I18N("Fertig")}</button>
                        </div>

                    </div>
                </div>
            </aside>
        )
    }

}
